import axios from 'axios';
import Backbone from 'backbone';
import ReactDOM from 'react-dom';
import React from 'react';
import $ from 'jquery';
import app from '../../app';
import { BackboneViewProps } from '../../types';
import OverviewComponent from './components/OverviewComponent';
import { getScriptCheckerStateBasedOnMappingMode } from '../utils';
import MappingsMode from '../enums/MappingsMode';
import { isUserReadOnly } from '../../utils';
import { getBongoUrl } from '../../common/utils/bongo';
import { fetchBusyRecords } from '../busyRecords';

const template = require('./audience_mapping.pug');

export default Backbone.View.extend({
  events: {
    'click #go_back': 'goBack',
    'click #new_audience': 'requestNewAudience',
  },

  async initialize(options: BackboneViewProps) {
    this.tenant = options.tenant;
    this.session = app.session;
    const user = this.session.get('user');
    this.isReadOnly = isUserReadOnly(user);
    [this.data, this.scriptCheckerData, this.busyRecords] = await Promise.all([
      this.getAudienceData(),
      getScriptCheckerStateBasedOnMappingMode(
        this.tenant,
        MappingsMode.audience
      ),
      fetchBusyRecords(this.tenant, 'audiences'),
    ]);
    this.scriptCheckerState = this.scriptCheckerData.data || false;
    this.render();
    this.renderAudience();
  },

  async getAudienceData() {
    try {
      const { data } = await axios.get(
        `${getBongoUrl()}/v1/org/${this.tenant}/data/mappings/audiences`
      );
      return data;
    } catch (_e) {
      return null;
    }
  },

  goBack() {
    Backbone.history.navigate(`/org/${this.tenant}/mapping`, true);
  },

  renderAudience() {
    const waitForPageReady = () => {
      const boxData = this.data?.map((item: UnknownObject) => {
        return { name: item.name, date: item.updated_at || item.created_at };
      });
      if (typeof $('#audienceMappingMain')[0] !== 'undefined') {
        ReactDOM.render(
          <OverviewComponent
            isReadOnly={this.isReadOnly}
            tenant={this.tenant}
            boxData={boxData}
            scriptCheckerState={this.scriptCheckerState}
            busyRecords={this.busyRecords}
          />,
          $('#audienceMappingMain')[0]
        );
      } else {
        setTimeout(waitForPageReady, 250);
      }
    };
    waitForPageReady();
  },

  render() {
    const html = template();
    this.$el.html(html);
    return this;
  },
});
